import React from "react";
import "./Mobile_Payment_Failed_Modal.css";
import Failed_Lottie from "../../Animation/Failed_Lottie/Failed_Lottie";

function Mobile_Payment_Failed_Modal({ successText, ...props }) {
  const handleGoBackToApp = () => {
    const params = new URLSearchParams(window.location.search);
    const orderId = params.get("orderId");

    if (!orderId) {
      return;
    }

    window.location.href = `riyara://payment/failed?order_id=${orderId}`;
  };

  return (
    <>
      <section className="Success_modal Payment_Success_Modal">
        <Failed_Lottie successText="Order Failed" />

        <div className="text-center mt-3">
          <h4>Payment Failed</h4>

          <p>
            Your payment could not be completed. Please try again from the
            mobile app.
          </p>

          <button
            type="button"
            className="go_back_app_btn"
            onClick={handleGoBackToApp}
          >
            Go Back to App
          </button>
        </div>
      </section>
    </>
  );
}

export default Mobile_Payment_Failed_Modal;
